module.exports = "/images/project_card_placeholder.png?69fda10461e59a0406413f26a6b10bc4";